import { FilterOperator as e, FilterType as t } from "../comps/box/filters.js";
const r = () => ({
  operator: e.GT,
  value: {
    "@type": t.SCALAR,
    value: void 0
  },
  negate: !1
}), o = () => ({
  operator: e.IN,
  value: {
    "@type": t.VALUE_LIST,
    values: []
  },
  negate: !1
});
export {
  o as getDefaultDimensionPredicate,
  r as getDefaultMetricPredicate
};
//# sourceMappingURL=FilterPopover.utils.js.map
